/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_APPLICATION_DETAILS_REQUEST,
  FETCH_APPLICATION_DETAILS_SUCCESS,
  FETCH_APPLICATION_DETAILS_FAILURE,
  FETCH_APPLICATION_DETAILS_SCREENSHOTS,
  FETCH_APPLICATION_DETAILS_ADDDITIONAL_DOCUMENT
} from "./ApplicationDetailsTypes";

const initialState = {
  loading: false,
   saving: false,  
  submissionDetails: {},
  error: "",
};

const aplicationDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPLICATION_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_APPLICATION_DETAILS_SUCCESS:
      return {
        loading: false,
        submissionDetails: action.payload,
        error: "",
      };
    case FETCH_APPLICATION_DETAILS_FAILURE:
      return {
        loading: false,
        submissionDetails: state.submissionDetails,
        error: action.payload,
      }
      case FETCH_APPLICATION_DETAILS_SCREENSHOTS:
        return {
          loading:false,
          submissionDetails:{...AddScreenShotsInsideTheData(action.payload.newSubmissionData,action.payload.screenShots)},
          error:""
        }
      case FETCH_APPLICATION_DETAILS_ADDDITIONAL_DOCUMENT:
        return{
          loading:false,
          submissionDetails:{...action.payload},
          error:""
        }
      case 'PUT_SUBMISSION_REQUEST':
      return {
        ...state,
        saving: true,
        error: null
      };

    case 'PUT_SUBMISSION_SUCCESS':
      return {
        ...state,
        saving: false,
        submissionDetails: action.payload,
        error: null
      };

    case 'PUT_SUBMISSION_FAILURE':
      return {
        ...state,
        saving: false,
        error: action.payload
      };
    default:
      return state;
  }
};

const AddScreenShotsInsideTheData=(newSubmissionData,screenShots)=>{
  let descriptions=[];
  descriptions= newSubmissionData.descriptions;
  let currentLanguage= sessionStorage.getItem('currentLanguage');
 descriptions.map((ele)=>{
      if(ele.language === currentLanguage)
        ele.screenshots=[...screenShots];
  });
  newSubmissionData.descriptions =[...descriptions];
  return newSubmissionData;
}

export default aplicationDetailsReducer;
